'use strict';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

var SignedSet = function SignedSet(name, sig, rrs) {
  _classCallCheck(this, SignedSet);

  this.name = name;
  this.sig = sig;
  this.rrs = rrs;
};

module.exports = SignedSet;
